import * as React from 'react'
import classnames from 'classnames'
import './index.scss'

export default class Player extends React.Component {
  static defaultProps = {
    sourceURL: '', // 资源路径
    maxDuration: 100, // 最大时间
    duration: 70, // 持续时间
    showDelete: false, // 是否显示删除按钮
    showProgress: true, // 是否开启进度条
    isOnlyPlay: true, // 是否只允许单独播放
    onDelete: (e) => e, // 删除回调事件
    onControl: (e) => e, // 父组件控制播放
    gutter: [8, 8], // 上下间距
  }

  constructor(props) {
    super(props)
    // 播放器实例
    this.audioRef = React.createRef()
    // 播放器控制条实例
    this.audioControlRef = React.createRef()
    // 进度条实例
    this.aduioProgressRef = React.createRef()
  }

  state = {
    paused: true, // 是否是暂停
    realWidth: 'initial', // 实际宽度
    touchActive: false, // 是否touch激活样式
  }

  maxWidth = 0 // 最大宽度
  minWidth = 160 // 最小的宽度
  progressTimer = null // 进度条定时器

  componentDidMount() {
    const audioElement = this.audioRef.current

    // 绑定首帧资源加载
    audioElement.addEventListener('loadeddata', this.onLoadeddata)
    // 绑定资源加载完毕
    audioElement.addEventListener('loadedmetadata', this.onLoadedmetadata)
    // 绑定资源播放完毕
    audioElement.addEventListener('ended', this.onEnded)
    // 监听播放事件
    audioElement.addEventListener('pause', this.onEnded)
    // active样式激活
    document.body.addEventListener('touchstart', () => {})
    // 计算宽度
    this.countPalyerWidth()
  }

  componentWillUnmount() {
    const audioElement = this.audioRef.current
    // 解绑事件
    audioElement.removeEventListener('loadedmetadata', this.onLoadedmetadata)
    audioElement.removeEventListener('ended', this.onLoadedmetadata)
    audioElement.removeEventListener('loadeddata', this.onLoadedmetadata)
  }

  /**
   * 计算播放器宽度
   */
  countPalyerWidth() {
    const {duration, maxDuration} = this.props
    // 获取最大宽度
    this.maxWidth = this.audioControlRef.current.offsetWidth
    // 如果最大宽度小于最小宽度 取最小宽度
    if (this.maxWidth < this.minWidth) {
      this.maxWidth = this.minWidth
    }
    // 真实宽度
    let realWidth = 0
    // 计算实际宽度
    if (duration > maxDuration) {
      // 如果时间大于100那就满宽度
      realWidth = this.maxWidth
    } else if (duration < 40) {
      // 如果时间小于40那就使用最小宽度
      realWidth = this.minWidth
    } else {
      realWidth = (duration / maxDuration) * this.maxWidth
      if (realWidth < this.minWidth) {
        // 如果实际宽度小于最小宽度 取最小宽度
        realWidth = this.minWidth
      }
    }

    this.setState({realWidth})
  }

  /**
   * 音频资源第一帧加载完毕
   * @param {Object} event
   */
  onLoadeddata = (event) => {
    // console.log('第一帧加载完毕');
  }

  /**
   * 音频资源播放完毕
   * @param {Object} event
   */
  onEnded = (event) => {
    event.stopPropagation()
    // 资源完毕后调用停止
    this.stop(event.target)
  }

  /**
   * 音频资源加载完毕
   * @param {Object} event
   */
  onLoadedmetadata = (event) => {
    // console.log('资源加载完毕');
  }

  /**
   * 播放事件
   * @param {Object} event
   */
  onPlayToggle = (event) => {
    event.stopPropagation()
    const audioElement = this.audioRef.current
    // 当前播放状态
    const paused = audioElement.paused

    // 如果当前是暂停状态
    if (paused) {
      // 进行播放
      this.play(audioElement)
    } else {
      // 暂停
      this.stop(audioElement)
    }
  }

  /**
   * 开始播放
   * @param {Object} audio 播放器
   */
  play(audio) {
    audio.play()
    // 设置播放状态
    this.setState({paused: false})
    // 计算播放进度
    this.startProgressTimer()
    // 如果当前有其他音频正在播放需要暂停其他音频
    this.stopOtherAudioPlayer()
  }

  /**
   * 暂停播放
   * @param {Object} audio 播放器
   */
  pause(audio) {
    audio.pause()
    // 设置播放状态
    this.setState({paused: true})
  }

  /**
   * 停止播放
   * @param {Object} audio 播放器
   */
  stop(audio) {
    this.pause(audio)
    // 播放时间重置为0
    audio.currentTime = 0.0
    // 重置进度条
    this.resetProgressTimer()
  }

  /**
   * 暂停其他正在播放的音频
   */
  stopOtherAudioPlayer() {
    if (!this.props.isOnlyPlay) return

    const audioElement = this.audioRef.current
    document.querySelectorAll('audio').forEach((element) => {
      // 如果element音频正在播放 && element 不是 audioElement
      if (!element.paused && audioElement !== element) {
        // 停止其播放
        element.pause()
      }
    })
  }

  /**
   * 播放进度控制
   */
  startProgressTimer() {
    // 如果未开启进度条直接return
    if (!this.props.showProgress) return
    // 播放进度
    let rate = 0
    // 播放总时长
    const {duration} = this.props
    // 计算每秒前进的的value
    const step = 10 / duration
    // 设置定时器
    this.progressTimer = setInterval(() => {
      rate += step
      // 设置进度条
      this.aduioProgressRef.current.setAttribute('value', rate)
      // 如果大于100了清除定时器
      if (rate > 100) {
        this.resetProgressTimer()
      }
    }, 100)
  }

  /**
   * 重置进度条
   */
  resetProgressTimer() {
    // 如果未开启进度条直接return
    if (!this.props.showProgress) return
    // 清除定时器
    clearInterval(this.progressTimer)
    // 重置进度条进度条
    this.aduioProgressRef.current &&
      this.aduioProgressRef.current.setAttribute('value', 0)
    // 清空
    this.progressTimer = null
  }

  /**
   * 删除当前音频
   * @param {Object} event
   */
  onDelete = (event) => {
    event.stopPropagation()
    event.preventDefault()
    // 先停止播放
    this.stop(this.audioRef.current)
    // 回调方法
    this.props.onDelete(event)
  }

  /**
   * 点击播放touch start
   * @param {Object} event
   */
  onPalyTouchStart = (event) => {
    event.stopPropagation()
    const audioElement = this.audioRef.current
    // 当前播放状态
    if (audioElement.paused && !this.touchTimer) {
      this.setState({touchActive: true})
    }
  }

  /**
   * 点击播放touch end
   * @param {Object} event
   */
  onPalyTouchEnd = (event) => {
    event.stopPropagation()
    this.setState({touchActive: false})
  }

  render() {
    const {sourceURL, showDelete, duration, gutter} = this.props
    const {paused, realWidth, touchActive, rate} = this.state
    // 上下间距
    const [top, bottom] = gutter

    return (
      <div
        className="audio-player"
        style={{marginTop: top, marginBottom: bottom}}
      >
        <div className="audio-player-container">
          <div
            className="control"
            ref={this.audioControlRef}
            onClick={this.onPlayToggle}
            style={{width: realWidth}}
            onTouchStart={this.onPalyTouchStart}
            onTouchEnd={this.onPalyTouchEnd}
          >
            {/* 进度条 */}
            <progress
              style={{width: realWidth}}
              className="progress"
              value={rate}
              max={100}
              ref={this.aduioProgressRef}
            />
            {/* 播放按钮 */}
            <div
              className={classnames({
                action: true,
                paused,
                active: touchActive,
              })}
            >
              <i
                className={classnames({
                  iconfont: true,
                  'icon-playCircle': paused,
                  'icon-zanting': !paused,
                })}
              />
            </div>
            {/* 播放音轨动画 */}
            <div className={classnames({wavy: true, playing: !paused})}>
              <div className="rect1" />
              <div className="rect2" />
              <div className="rect3" />
              <div className="rect4" />
              <div className="rect5" />
            </div>
            {/* 播放时间 */}
            <div className="time">{duration}″</div>
            {/* 删除按钮 */}
            <div
              onClick={this.onDelete}
              onTouchStart={(event) => event.stopPropagation()}
              onTouchEnd={(event) => event.stopPropagation()}
              className={classnames({delete: true, visible: showDelete})}
            >
              <i className="iconfont icon-guanbi" />
            </div>
          </div>
        </div>
        {/* 实际播放器 */}
        <audio
          // controls
          ref={this.audioRef}
          preload="metadata"
          crossOrigin="anonymous"
          src={sourceURL}
        />
      </div>
    )
  }
}
